module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYCAYAAAARfGZ1AAABZUlEQVRIS+3VTytEURjH8e9vYSl/lshO/iwQs7G08hKkxIh3oGSnbOQ1kD9ZKG9BWUlREmWDWIwNygJb/XTkTjN3Ztxh7lg5y3uf8znPOefpOaKKYbsX2AKGgRNgWtJ10lQlBYT/ti+BvoLYM0lDSXMr4rbDvzFgApgqA20Cu5L2Ky1SFrfdBWwDI0nZAYdhcUl38dgS3PYAcAC0VgFHIU/AqKRwfPlRhNtuAi6Azh/AUWjIvF/SW/Qhjq8CC7+AoynLkpZKcNsNwAPQUgP+CLRJeg9GPnPb4fKOaoCjqRlJp3F8EthJAR+XtBfHZ4H1FPCspFDGRccyB6ylgM9ICq3iHy86zD86Ftuh822E4k/hMiPiHsjKdg7oSBGOqNuAvwCNdcCfA74IrNQBn//sLbZ7gPbCuq9hMQM5SVeJb6jt5gptIZTc63dJJOJfO4s/0OeSBpN2Vy3eDYQHOQMcAyHrmyT8A+cff4xGzcKrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Notifications/bell.png
// module id = 254
// module chunks = 0